import styled from "styled-components";

import { color } from "../../theme/color";

type SegmentedProps<T extends string> = { label: string; options: [T, string][]; value: T; onChange(value: NoInfer<T>): void };

/** A choice between two or three options, side by side. `options` pairs each value with its text. */
export function Segmented<T extends string>({ label, options, value, onChange }: SegmentedProps<T>) {
    return (
        <Group role="group" aria-label={label}>
            {options.map(([option, text]) => (
                <Option key={option} aria-pressed={option === value} onClick={() => onChange(option)}>
                    {text}
                </Option>
            ))}
        </Group>
    );
}

const Group = styled.div`
    display: flex;
    padding: 3px;
    border-radius: 11px;
    background: ${color.surface};
`;

const Option = styled.button`
    flex: 1;
    height: 38px;
    padding: 0 12px;
    border: 0;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    background: transparent;
    color: ${color.textMuted};

    &[aria-pressed="true"] {
        background: ${color.background};
        color: ${color.text};
        box-shadow: 0 1px 2px ${color.shadow};
    }
`;
